import { useId, type InputHTMLAttributes } from "react";

type Props = InputHTMLAttributes<HTMLInputElement> & { label: string; hint?: string; error?: string };
export function Field({ label, hint, error, id, ...props }: Props) {
  const generatedId = useId();
  const fieldId = id || props.name || generatedId;
  return <div className="field"><label htmlFor={fieldId}>{label}</label>{hint && <p className="field-hint" id={`${fieldId}-hint`}>{hint}</p>}<input id={fieldId} aria-invalid={Boolean(error)} aria-describedby={[hint && `${fieldId}-hint`, error && `${fieldId}-error`].filter(Boolean).join(" ") || undefined} {...props} />{error && <p className="field-error" id={`${fieldId}-error`} role="alert">{error}</p>}</div>;
}
